import { createSubscriber } from 'react-sweet-state';
import Store, { type Actions } from '../store';
import type { State } from '../types';

export default createSubscriber<State, Actions>(Store, {
	displayName: 'CommentVisibilitiesSubscriber',
});
